import React from "react";
import "./rbs.css";
import rfidImage from "../../../assets/service-pictures/rfid-barcode.png";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";
import Applications from "./Applications";

const RFIDAndBarcodeSolutions = () => {
  return (
    <div className="rbs-service-wrapper">
      <Particles title="RFID & Barcode Solutions" image={rfidImage} />
      <HeroSection />
      <Applications />
      <OurApproach />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default RFIDAndBarcodeSolutions;
